import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "google source icon",
	style: { color: "#4285F4" },
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#4285F4",
			d: "M62 32c0-2.2-.2-4.3-.6-6.3H32v11.9h16.8c-.7 3.8-2.8 7-6 9.2v7.7h9.8C58.3 49.1 62 41.2 62 32z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#34A853",
			d: "M32 62c8.1 0 14.9-2.7 19.9-7.4l-9.8-7.7c-2.7 1.8-6.1 2.9-10.1 2.9-7.8 0-14.4-5.3-16.8-12.4H5.1v7.9C10 55.3 20.2 62 32 62z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FBBC05",
			d: "M15.2 37.4c-.6-1.8-.9-3.6-.9-5.4s.3-3.7.9-5.4v-7.9H5.1C3.1 22.6 2 27.1 2 32s1.1 9.4 3.1 13.3l10.1-7.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EA4335",
			d: "M32 13.1c4.4 0 8.3 1.5 11.4 4.5l8.5-8.5C46.9 4.2 40.1 2 32 2 20.2 2 10 8.7 5.1 18.7l10.1 7.9C17.6 18.4 24.2 13.1 32 13.1z"
		})
	]
});
export default SvgGoogle;
